import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import {
  OlsConfigStore,
  ShopViewConstants
} from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import dataAids from '../../../constants/dataAids';
import { mapContextToProps } from '../OlsShopContext';

const yotpoContainerStyles = renderMode => {
  const editPreviewCheck = renderMode !== 'PUBLISH';
  return {
    pointerEvents: `${editPreviewCheck ? 'none' : 'inherit'}`,
    opacity: `${editPreviewCheck ? '0.5' : '1'}`
  };
};

const formatDescription = description_raw => {
  if (!description_raw) {
    return null;
  }
  let result;

  try {
    result = JSON.parse(description_raw).blocks[0].text;
  } catch (e) {
    result = description_raw;
  }

  if (result.length > 1000) {
    result = `${result.substring(0, 999)}...`;
  }

  return result;
};

class YotpoComponent extends React.Component {
  render() {
    const { app_key: appKey } = OlsConfigStore.getState().yotpo_config || {};
    const { product, className, style, type, domainName, getLinkProps } = this.props;
    if (!appKey || !product) {
      return null;
    }

    const { id, name, slug, description_raw } = product;
    const protocol = typeof window !== 'undefined' ? window.location.protocol : 'https:';
    const siteUrl = `${protocol}//${domainName}`;
    const linkProps = getLinkProps(ShopViewConstants.PRODUCT_DETAIL, { slug }, true);
    const productUrl = linkProps && encodeURIComponent(linkProps.href);
    const assets = product.assets || product.images;
    let assetUrl =
      assets && assets.length ? assets[0].large_url : OlsConfigStore.getState().noProductImage;
    assetUrl = encodeURIComponent(`https:${assetUrl}`);
    const description = formatDescription(description_raw);
    const domain = type === 'stars' ? siteUrl : '';

    const { Block } = UX2.Element;
    return (
      <Block
        className={ className }
        style={ style }
        data-appkey={ appKey }
        data-domain={ domain }
        data-product-id={ `${id}` }
        data-name={ name }
        data-description={ description }
        data-url={ productUrl }
        data-image-url={ assetUrl }
      />
    );
  }
}

YotpoComponent.propTypes = {
  type: PropTypes.string,
  product: PropTypes.object,
  className: PropTypes.string,
  style: PropTypes.any,
  domainName: PropTypes.string,
  getLinkProps: PropTypes.func
};

YotpoComponent.defaultProps = {
  type: 'stars',
  getLinkProps: () => {}
};

const Yotpo = mapContextToProps(YotpoComponent, context => ({
  domainName: context.domainName,
  getLinkProps: context.getLinkProps
}));

export const ProductStarRating = ({ product, containerStyle, containerClass, renderMode }) => {
  const { app_key: appKey } = OlsConfigStore.getState().yotpo_config || {};
  if (!appKey || !product) {
    return null;
  }

  const productStarRatingDataAid = `${dataAids.PRODUCT_STAR_RATING_RENDERED}`;
  const productDetailPage = containerClass === 'product-detail';
  const styles = {
    outer: {
      textAlign: 'center',
      ...containerStyle,
      marginBottom: `${productDetailPage ? 'small' : ''}`
    },
    inner: {
      display: 'inline-block',
      width: 'auto',
      ...yotpoContainerStyles(renderMode)
    }
  };

  if (productDetailPage) {
    styles.outer['@sm'] = { textAlign: 'left' };
  }

  const { Block } = UX2.Element;
  return (
    <Block
      className={ `ratings-review-wrapper ${containerClass}` }
      data-aid={ productStarRatingDataAid }
      style={ styles.outer }
    >
      <Block className='single-product-review'>
        <Yotpo product={ product } className='yotpo bottomLine' style={ styles.inner } type='stars' />
      </Block>
    </Block>
  );
};

ProductStarRating.propTypes = {
  product: PropTypes.object.isRequired,
  containerStyle: PropTypes.object,
  containerClass: PropTypes.string,
  renderMode: PropTypes.string
};

ProductStarRating.defaultProps = {
  containerStyle: {},
  containerClass: '',
  renderMode: ''
};

export const ProductReviews = ({ product, renderMode }) => {
  const { app_key: appKey } = OlsConfigStore.getState().yotpo_config || {};
  if (!appKey || !product) {
    return null;
  }

  const productReviewsDataAid = `${dataAids.PRODUCT_REVIEWS_RENDERED}`;
  const { Block } = UX2.Element;

  return (
    <Block
      className='review-wrapper'
      data-aid={ productReviewsDataAid }
      style={ yotpoContainerStyles(renderMode) }
    >
      <Yotpo product={ product } className='yotpo yotpo-main-widget' type='reviews' />
    </Block>
  );
};

ProductReviews.propTypes = {
  product: PropTypes.object.isRequired,
  renderMode: PropTypes.string
};

ProductReviews.defaultProps = {
  renderMode: ''
};
